import { createQueryKey } from '../../query/createQueryKeyFactory';
import { QueryKey, QueryKeyParam } from '../../query/types';

const formKeys = <T extends QueryKey>(keys: T) => {
  const key = [...keys, 'forms'] as const;
  return createQueryKey({
    all: key,
    id: <U extends QueryKeyParam>(itemId: U) =>
      createQueryKey({
        all: [...key, itemId] as const,
        detail: [...key, itemId, 'detail'] as const,
      }),
  });
};

export { formKeys };
